import { Button } from '@ps/sports-ui-component-library';
import { Translation } from '@ps/web-shared-components';
import type { MultipleOpportunity, SingleOpportunity } from '@ps/web-sports-api-types';
import React from 'react';
import { useDispatch } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import type { StarsWebExtraWallet } from '@swf/core/models/sports/extraWallets/types';
import { getIsWalletBonusCash } from '@swf/core/models/sports/extraWallets/utils/getIsWallet';
import type { Dispatch } from '@swf/core/store';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';

import usePromotionPicker from '../../../../../../../../hooks/usePromotionPicker';

import {
  TXTCLI_Add,
  TXTCLI_ExpiresX_N0,
  TXTWCL_Add_promotion,
  TXTWCL_N0_Bonus_Cash,
  TXTWCL_N0_Free_Bet
} from './Promotion.messages.json';
import styles from './Promotion.scss';

export interface PromotionProps {
  wallet: StarsWebExtraWallet;
  opportunity: SingleOpportunity | MultipleOpportunity;
  numberOfLines: number;
}

const Promotion: React.FC<PromotionProps> = ({ wallet, opportunity, numberOfLines }) => {
  const isBonusCash = getIsWalletBonusCash(wallet);
  const dispatch = useDispatch<Dispatch>();
  const { formatMessage } = useRegulatoryIntl();

  const { setPromotionFieldValue } = usePromotionPicker(
    opportunity,
    opportunity.id,
    numberOfLines,
    wallet.id
  );

  return (
    <div className={styles.promotion}>
      <div className={styles.promotionInfo}>
        <span className={styles.promotionAmount} id={`${wallet.id}-amount`}>
          <Translation
            {...(isBonusCash ? TXTWCL_N0_Bonus_Cash : TXTWCL_N0_Free_Bet)}
            values={{
              0: <CurrencyAmount value={wallet.amount} dollarValue currency={wallet.currency} />
            }}
          />
        </span>
        <span className={styles.promotionExpiry}>
          <Translation
            {...TXTCLI_ExpiresX_N0}
            values={{
              0: <FormattedDateTime date={wallet.expiry} format="short" hideTime />
            }}
          />
        </span>
      </div>

      <Button
        aria-label={formatMessage(TXTWCL_Add_promotion)}
        aria-describedby={`${wallet.id}-amount`}
        variant="brand-promotion"
        size="small"
        onClick={() => {
          setPromotionFieldValue();
          dispatch.betSlip.promotionPickerToggled(undefined);
        }}
      >
        <Translation {...TXTCLI_Add} />
      </Button>
    </div>
  );
};

export default Promotion;
